module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAADnSURBVHja7JVNDoIwEEYfhIU7decSb2Dc+ZMoV+YCigfwCkBidGUUL4ALB0MIUoiFxsiXNCTTdl6/aWnhpQnwANKW21F42PJdA1fAUrQRkJTEE+lTzR8Dbh68BA6o5QJRSTzKEiq0B7Z58ArYdQAOAC8DD4CZrKYLx5sMPAfOHxIWNQXCkngofSpFcshcW8ocUE/fOn7vsw0sapZZJ9gDuDSYdJPfpqghcG+w+NiSmhtRqmlsozy2KbdOw/F+hTO/zVJr215jpe7BPbgH9+DfAzsac2V3vlXxBljGHf/f6+QAJwOu4+cAAKlLaMLS2uYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/shipment2.png
// module id = 810
// module chunks = 0